<h2>Welcome</h2>
<div *ngFor="let row of data$ | async">
  <h6>{{ row.claim }}</h6>
  <p>{{ row.value }}</p>
</div>
